export default "__VITE_ASSET__d87980e0__"